export default __webpack_public_path__ + "images/mahesh.3529400d1e90ee02ce17.png";